/**
  * 封装axios
*/
import QS from "qs";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import Vue from "vue";
import {
  messageShow
} from "@/common/el-component";

import {ERR_OK, OPER_CODE, MSG, RETRY_TIMES, RETRY_DELAY, NAME_SPACE, BASE_URL} from "./config";

let service = axios.create({
  baseURL: BASE_URL(),
  timeout: 60*1000,
  // withCredentials: true,
  headers: {
    "Access-Control-Allow-Credentials": true
  }
  // crossDomain: true
});

function initRequestRetryCount(config){

  config.headers[NAME_SPACE] = config.headers[NAME_SPACE] || {};
  let curRetryCount = config.headers[NAME_SPACE].retryCount = config.headers[NAME_SPACE].retryCount || 0;

  return curRetryCount;
}

// 添加请求拦截器
// 这个拦截器中的config 就是每次发送请求时，我们所写的config
service.interceptors.request.use(
  function(config){
    // initRequestRetryCount(config);
    // let {url} = config;
    // console.log("config==",config.data);
    let token = store.state.token;
    let tokenName = store.state.tokenName;
    if(token){
      config.headers[tokenName] = `${store.state.token}`;
    }

    return config;
  },
  function(error){
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(function (response){
  // 对响应数据做点什么 这个里面的内容都代表响应成功
  let res = response.data;
  // let {config} = response;
  // const {url} = config;
  // let curCount = initRequestRetryCount(config);
  //
  // let backoff = new Promise((resolve)=>{
  //   setTimeout(()=>{
  //     resolve();
  //   },RETRY_DELAY);
  // });

  if(response.status !== ERR_OK){
    // if(response.status === 401 || response.status === 403){
    if(response.status === 401){
      // 缺少redirect参数进行登录重新调用
      sessionStorage.clear();

      router.push({
        path: "/login",
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    }
    else{
      return Promise.reject(res);
    }
  }
  else{
    if(res.code && res.code == OPER_CODE){
      return Promise.resolve(res);
    }
    else{
      // if(url !== "/api/user/login"){
      //   messageShow({msg: "服务器忙碌中"});
      // }
      if(res.code && res.code == 500 && res.errorCode && res.errorCode == "11012"){
        router.push({
          path: "/login",
          query: {
            redirect: router.currentRoute.fullPath
          }
        });
      }
      else{
        return Promise.reject(res);
      }
    }
  }
}, function (error) {
  // 对响应错误做点什么

  // let {config, code, message} = error;
  // const {url} = config;
  // let curCount = initRequestRetryCount(config);
  // let backoff = new Promise((resolve)=>{
  //   setTimeout(()=>{
  //     resolve();
  //   },RETRY_DELAY);
  // });

  // /* ECONNABORTED 代表请求超时*/
  /*
  if(code === "ECONNABORTED" && (message.indexOf("timeout") !== -1) || ((!error.response) && message.indexOf("Network Error") !== -1)){
    curCount ++;
    config.headers[NAME_SPACE].retryCount = curCount;
    return backoff.then(()=>{
      return service(config);
    });
  }
  */

  let {status} = error.response;
  if(status == 401){
  // if(false){
    sessionStorage.clear();

    const {query} = router.currentRoute;

    router.push({
      path: "/login",
      query: {
        redirect: router.currentRoute.fullPath
      }
    });
  }
  else{
    // if(url !== "/api/user/login"){
    //   messageShow({msg: "服务器忙碌中"});
    // }
    return Promise.reject(error);
  }
});

export async function get({url, params}){
  try{
    let res = await service({
      method: "get",
      headers:{
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      },
      url,
      params,
    });
    return Promise.resolve(res);
  }
  catch(e){
    console.error(e,url);
    // console.log("2222222222222");
    return Promise.reject(e);
  }
}

export async function post({url,params,type=""}){
  try{
    let res = await service({
      method: "post",
      url,
      data: params,
      headers: {
        "Content-Type": type==="file"?"multipart/form-data;charset=utf-8":(type==="query"?"application/x-www-form-urlencoded;charset=utf-8":"application/json;charset=utf-8")
      },
      transformRequest: [function(data, config){
        if(!config["Content-Type"]){
          return QS.stringify(data);
        }
        switch(config["Content-Type"].toLowerCase()){
          case "application/json;charset=utf-8":
            return JSON.stringify(data);
          case "multipart/form-data;charset=utf-8":
            console.log("data===",data);
            return data;
          default:
            return QS.stringify(data);
        }
      }]
    });
    return Promise.resolve(res);
  }
  catch(e){
    console.error(e,url)
    return Promise.reject(e);
  }
};

export async function put({url,params,type=""}){

  try{
    let res = await service({
      method: "put",
      url,
      data: params,
      headers: {
        "Content-Type": type==="file"?"multipart/form-data;charset=utf-8":(type==="query"?"application/x-www-form-urlencoded;charset=utf-8":"application/json;charset=utf-8")
      },
      transformRequest: [function(data, config){

        if(!config["Content-Type"]){
          return QS.stringify(data);
        }
        switch(config["Content-Type"].toLowerCase()){
          case "application/json;charset=utf-8":
            return JSON.stringify(data);
          case "multipart/form-data;charset=utf-8":
            return data;
          case "application/x-www-form-urlencoded;charset=utf-8":

            let tmpStr = "";
            for(let key in data){
              tmpStr += encodeURIComponent(key) + "=" + encodeURIComponent(data[key]) + "&";
            }
            tmpStr = tmpStr.slice(0, -1);
            return tmpStr;
          default:
            return QS.stringify(data);
        }
      }]
    });
    return Promise.resolve(res);
  }
  catch(e){
    console.error(e,url)
    return Promise.reject(e);
  }
};

export async function Delete({url, params}){
  try{
    let res = await service({
      method: "delete",
      headers:{
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      },
      url,
      data: params
    });

    return Promise.resolve(res);
  }
  catch(e){
    console.error(e, url);
    return Promise.reject(e);
  }
}

export default service;
